export const UPDATE_SETTINGS = 'UPDATE_SETTINGS'
export const UPDATE_STRUCTURE_SEARCH = 'UPDATE_STRUCTURE_SEARCH'
